import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import AdsTagsService from "../../../services/OrderingServices/AdsTagsService";

const AdFilterCard = ({
  filters,
  handleFilterChange,
  handleClearFilters,
  setCurrentPage,
  onAddNewClick,
}) => {
  const [tags, setTags] = useState([]);

  // Fetch all tags only if no tags are preselected
  async function fetchAllTags() {
    try {
      const response = await AdsTagsService.searchTags("");
      const tagsList = Array.isArray(response)
        ? response
        : response?.data || [];

      const tagNames = tagsList.map((tag) => tag.name || tag).filter(Boolean);

      setTags(tagNames);
    } catch (error) {
      console.error("Failed to fetch tags", error);
      setTags([]);
    }
  }

  useEffect(() => {
    // Fetch tags only if filters.tags is empty or undefined
    if (!filters.tags || filters.tags.length === 0) {
      fetchAllTags();
    } else {
      // Use provided tags if any
      setTags(filters.tags);
    }
  }, [filters.tags]);

  return (
    <Row>
      <Col lg="12">
        <Card className="border-0 shadow-sm">
          <CardHeader className="bg-light">
            <Row className="align-items-center justify-content-between w-100">
              <Col md="auto">
                <h5 className="mb-0 d-flex align-items-center gap-2">
                  <i className="bx bx-filter-alt"></i> Search & Filter
                </h5>
              </Col>

              <Col md="auto" className="d-flex gap-2">
                {/* <Button
                  color="primary"
                  size="sm"
                  onClick={() => setCurrentPage(1)}
                >
                  <i className="bx bx-search me-2"></i>Apply Filters
                </Button> */}

                <Button
                  color="secondary"
                  outline
                  size="sm"
                  onClick={handleClearFilters}
                >
                  <i className="bx bx-reset me-2"></i>Clear All
                </Button>

                <Button color="success" size="sm" onClick={onAddNewClick}>
                  <i className="bx bx-plus me-2"></i>
                  New Ad
                </Button>
              </Col>
            </Row>
          </CardHeader>

          <CardBody>
            <Row className="g-3">
              {/* Search Text */}
              <Col md="4">
                <FormGroup>
                  <Label className="small fw-bold">Search Text</Label>
                  <Input
                    type="text"
                    placeholder="Search by title..."
                    value={filters.searchText || ""}
                    onChange={(e) =>
                      handleFilterChange("searchText", e.target.value)
                    }
                  />
                </FormGroup>
              </Col>

              {/* Status */}
              <Col md="4">
                <FormGroup>
                  <Label className="small fw-bold">Status</Label>
                  <Select
                    options={[
                      { value: "", label: "All Status" },
                      { value: "true", label: "Active" },
                      { value: "false", label: "Inactive" },
                    ]}
                    value={
                      filters.isActive
                        ? {
                            value: filters.isActive,
                            label:
                              filters.isActive === "true"
                                ? "Active"
                                : "Inactive",
                          }
                        : { value: "", label: "All Status" }
                    }
                    onChange={(selected) =>
                      handleFilterChange("isActive", selected?.value || "")
                    }
                    isClearable
                    placeholder="Select status..."
                  />
                </FormGroup>
              </Col>

              {/* Tags */}
              <Col md="4">
                <FormGroup>
                  <Label className="small fw-bold">Tags</Label>
                  <Select
                    options={tags.map((tag) => ({
                      value: tag,
                      label: tag,
                    }))}
                    value={(filters.tags || []).map((tag) => ({
                      value: tag,
                      label: tag,
                    }))}
                    onChange={(selected) =>
                      handleFilterChange(
                        "tags",
                        selected ? selected.map((s) => s.value) : [],
                      )
                    }
                    isMulti
                    isClearable
                    placeholder="Select tags..."
                  />
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AdFilterCard;
